var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecommendedConfiguration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "thumbs-up"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 10.4155C1.6665 9.49503 2.4127 8.74886 3.33317 8.74886C4.71388 8.74886 5.83317 9.86811 5.83317 11.2489V14.5822C5.83317 15.9629 4.71388 17.0822 3.33317 17.0822C2.4127 17.0822 1.6665 16.336 1.6665 15.4155V10.4155Z",
    stroke: "#141B34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8988 6.50408L12.6768 7.22081C12.495 7.80812 12.4041 8.10177 12.474 8.33369C12.5306 8.52128 12.6548 8.68303 12.824 8.78945C13.0332 8.92095 13.3496 8.92095 13.9824 8.92095H14.3191C16.4608 8.92095 17.5317 8.92095 18.0375 9.55495C18.0953 9.62736 18.1467 9.70444 18.1912 9.78528C18.5803 10.4923 18.1379 11.4448 17.2532 13.3498C16.4413 15.0979 16.0353 15.972 15.2815 16.4865C15.2086 16.5363 15.1336 16.5833 15.0568 16.6273C14.2632 17.0822 13.28 17.0822 11.3135 17.0822H10.887C8.50459 17.0822 7.3134 17.0822 6.57329 16.3651C5.83317 15.6479 5.83317 14.4938 5.83317 12.1854V11.3741C5.83317 10.161 5.83317 9.55453 6.04845 8.99936C6.26374 8.4442 6.67596 7.98773 7.50041 7.0748L10.9099 3.29933C10.9954 3.20464 11.0382 3.15729 11.0759 3.12449C11.4278 2.81826 11.9708 2.85273 12.2785 3.20082C12.3115 3.23811 12.3475 3.29045 12.4195 3.39514C12.5322 3.5589 12.5885 3.64079 12.6377 3.7219C13.0772 4.44814 13.2102 5.31083 13.0088 6.12982C12.9863 6.22129 12.9572 6.31561 12.8988 6.50408Z",
    stroke: "#141B34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecommendedConfiguration);
export default __webpack_public_path__ + "static/media/recommended_configuration.86fbf9d8a9d8caf3a6130ecfcbb960f3.svg";
export { ForwardRef as ReactComponent };